import { useEffect, useState } from 'preact/hooks';
import { Api, type AuditEntry } from '../../api';
import { formatDate, Spinner } from '../../components/ui';
import { attempt } from '../../state';

function actorLabel(actor: string): string {
  if (actor === 'ui') return 'You';
  if (actor === 'system') return 'Server admin';
  const [kind, name] = actor.split(/:(.*)/);
  if (kind === 'mcp') return `${name} (MCP)`;
  if (kind === 'token') return `${name} (API token)`;
  if (kind === 'admin') return `Admin ${name}`;
  return actor;
}

function describe(e: AuditEntry): string {
  const p = e.payload ?? {};
  switch (e.action) {
    case 'link.create':
      return `added “${p.title}”`;
    case 'link.update':
      return `edited a link${p.after?.title ? ` (now “${p.after.title}”)` : ''}`;
    case 'link.move':
      return 'moved a link to another section';
    case 'link.delete':
      return `deleted “${p.link?.title ?? 'a link'}”`;
    case 'link.reorder':
      return 'reordered links';
    case 'section.create':
      return `created section “${p.name}”`;
    case 'section.update':
      return 'changed a section';
    case 'section.delete':
      return `deleted section “${p.section?.name ?? ''}”${p.links?.length ? ` and ${p.links.length} links` : ''}`;
    case 'section.reorder':
      return 'reordered sections';
    case 'settings.update':
      return 'changed settings';
    case 'import.merge':
    case 'import.replace':
      return `imported ${p.linksCreated} links (${e.action.split('.')[1]})`;
    case 'passkey.add':
      return `added passkey “${p.name}”`;
    case 'passkey.delete':
      return 'removed a passkey';
    default:
      return e.action.replace(/[._]/g, ' ');
  }
}

export function Activity() {
  const [entries, setEntries] = useState<AuditEntry[] | null>(null);
  const [more, setMore] = useState(true);

  const load = async (before?: number) => {
    const res = await Api.audit(before);
    setEntries((prev) => [...(before ? (prev ?? []) : []), ...res.entries]);
    setMore(res.entries.length === 50);
  };
  useEffect(() => {
    void attempt(() => load());
  }, []);

  if (!entries) return <Spinner />;
  return (
    <>
      <h2>Activity</h2>
      <p class="muted">Changes to your page, including ones made by Claude or Grok.</p>
      <ul class="rows">
        {entries.map((e) => (
          <li key={e.id} class="row">
            <div>
              <span>
                <strong>{actorLabel(e.actor)}</strong> {describe(e)}
              </span>
              <span class="muted">{formatDate(e.createdAt)}</span>
            </div>
          </li>
        ))}
        {entries.length === 0 && <li class="muted">Nothing yet.</li>}
      </ul>
      {more && entries.length > 0 && (
        <button type="button" class="button" onClick={() => attempt(() => load(entries.at(-1)!.id))}>
          Load more
        </button>
      )}
    </>
  );
}
